<template>
    <div class="nav" v-if="loading">
        <div class="w">
            <div class="user-info">
                <span class="user not-login">
                    <span class="link js-login" style="margin-right: 65px" @click="goHome()">高端全屋智能系统专家</span>
                    <span v-if="adviceList && adviceList.title" class="link js-login" @click="informationdialog = true">{{adviceList.title}}</span>
                </span>
            </div>
            <ul class="nav-list">
                <!-- <li class="nav-item">
                    <a class="link" @click="loadPage('user-cart')">
                        <img class="shopping-cart" src="/image/img/shopping-cart.png" alt="">
                        购物车
                        <span class="cart-count">{{allCartLength > 100 ? '99+' : (allCartLength || 0)}}</span>
                    </a>
                </li> -->
                <li class="nav-item p-0" v-show="loginName == null || loginName === ''">
                    <ul>
                      <li class="nav-item">
                            <span class="link js-login" @click="goSignIn">登录</span>
                      </li>
                      <li class="nav-item">
                            <span class="link js-login" @click="goSignUp">注册</span>
                      </li>
                      <li class="nav-item">
                            <a class="link" href="https://www.unisiot.com/" target="_blank">关于UIOT</a>
                      </li>
                    </ul>
                </li>
                <li class="nav-item p-0" v-show="loginName != null && loginName !== ''">
                    <ul>
                      <li class="nav-item">
                          <span class="link-text">
                              欢迎，
                              <span class="username">{{loginName}}</span>
                          </span>
                          <span class="link js-logout" @click.prevent="logout">退出</span>
                      </li>
                      <li class="nav-item">
                          <a class="link" href="javascript:void(0)" @click.prevent="loadPage('user-center')">个人中心</a>
                      </li>
                      <li class="nav-item">
                          <a class="link" href="https://www.unisiot.com/" target="_blank">关于UIOT</a>
                      </li>
                    </ul>
                </li>
            </ul>
        </div>
        <el-dialog
            :visible.sync="informationdialog"
            v-if="informationdialog"
            width="50%"
            center
            :show-close="false"
            :modal-append-to-body="true"
            :close-on-click-modal="false">
            <div slot="title">
                <p class="font-22 m-b-10">{{adviceList.title}}</p>
                <p class="font-16" style="text-align: left">{{adviceList.createTime}}</p>
                <hr>
            </div>
            <div class="font-16 ql-snow" style="line-height: 30px;">
                <div class="ql-editor">
                    <p v-html="adviceList.content"></p>
                </div>
            </div>
            <div slot="footer" v-if="adviceList.isShow === 1">
                <el-button type="primary" @click="changeReadStatus">知道了</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        computed: {
            loginName() {
                return this.$store.getters.getLoginName
            },
            allCartLength() {
                return this.$store.getters.getAllCartLength
            }
        },
        data() {
            return {
                loading: false,
                adviceList: null,
                informationdialog: false,
            }
        },
        created() {
            this.adviceList = null
        },
        methods: {
            getAdviceList() {
                this.ajax({
                    url: `/adviceRoll/getNotReadList`,
                    type: 'get',
                    success: (data) => {
                        this.loading = true
                        if (data.result.length > 0) {
                            this.adviceList = data.result[0]
                            this.adviceList.createTime = this.adviceList.createTime.slice(0, 10) + ' ' + this.adviceList.createTime.slice(11, 19)
                            this.informationdialog = true
                        }
                    },
                    error: (msg) => {
                        this.$pcMessage.error(msg)
                    }
                })
            },
            // 已读
            changeReadStatus() {
                this.ajax({
                    url: `/adviceRollLog`,
                    type: 'POST',
                    data: {
                        adviceRollId: this.adviceList.id
                    },
                    success: (data) => {
                        this.informationdialog = false
                    },
                    error: (msg) => {
                        this.$pcMessage.error(msg)
                    }
                })
            }
        }
    }
</script>
<style lang="scss">
    .nav {
        height: 40px;
        line-height: 40px;
        background: #F8F9FA;
        box-shadow: 0px 1px 0px 0px #F0F1F2;
    }

    /* 用户部分 */
    span.js-login{
        color: #999;
    }

    .nav .user {
        float: left;
    }

    .nav .user.login {
        display: block;
    }

    .nav .user.not-login {
        display: block;
    }

    .nav .user .link {
        margin-right: 5px;
    }

    .js-logout{
        margin-left: 10px;
    }

    .shopping-cart{
        width: 15px;
        display: inline;
    }
    .cart-count{
      width: 14px;
      height: 14px;
      background: #BC5BA7;
      color: #ffffff;
      border-radius: 50%;
      padding: 0px 3.5px;
    }
    /* 导航链接部分 */
    .nav .nav-list {
        float: right;
    }

    .nav .nav-list .nav-item {
        display: inline-block;
        margin-left: 5px;
        position: relative;
        padding: 0 8px;
    }

    .nav .nav-list .nav-item:not(:last-child)::after{
      content: "|";
      position: absolute;
      right: -6px;
      color: #D4D7D9;
    }

    .p-0{
      padding: 0px !important;
      margin: 0px !important;
    }

    @import '../../../assets/styles/quill.format.css';

    .ql-editor .ql-align-center img {
        margin: 0 auto;
    }
    .ql-editor .ql-align-right img {
        margin-left: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/top-nav/index.vue